import { render, staticRenderFns } from "./quotation-channel.vue?vue&type=template&id=1a284a4b&scoped=true"
import script from "./quotation-channel.vue?vue&type=script&lang=js"
export * from "./quotation-channel.vue?vue&type=script&lang=js"
import style0 from "./quotation-channel.vue?vue&type=style&index=0&id=1a284a4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a284a4b",
  null
  
)

export default component.exports